<ng-container *transloco="let t; read: 'time-entries'">
  <div class="balances mbs">
    <table>
      <tr>
        <td>{{ t("flexTimeBalance") }}:</td>
        <td>{{ (currentEmployee$ | async)?.flexTimeBalanceObj?.hours }} h {{(currentEmployee$ | async)?.flexTimeBalanceObj?.minutes | number : "2.0"}} min</td>
      </tr>
      <tr>
        <td>{{ t("preWorkTimeBalance") }}:</td>
        <td>{{ (currentEmployee$ | async)?.preWorkTimeBalanceObj?.hours }}h {{(currentEmployee$ | async)?.preWorkTimeBalanceObj?.minutes | number : "2.0"}} min</td>
      </tr>
      <tr *ngIf="(tenantSettings$ | async)?.hasOvertime">
        <td>{{ t("overtimeBalance") }}:</td>
        <td>{{ (currentEmployee$ | async)?.overtimeBalanceObj?.hours }} h {{(currentEmployee$ | async)?.overtimeBalanceObj?.minutes | number : "2.0"}} min</td>
      </tr>
      <tr>
        <td>{{ t("vacationBalance") }}:</td>
        <td>{{ t("vacationBalanceOfTotal", { balance: (currentEmployee$ | async)?.vacationBalance, total: (currentEmployee$ | async)?.vacationEntitlement }) }}</td>
      </tr>
    </table>
  </div>

  <h3>{{ t("tracking.title") }}</h3>
  <app-time-tracking-start-stop></app-time-tracking-start-stop>

  <kendo-tabstrip class="mtm">
    <kendo-tabstrip-tab [title]="t('tracking.today')" [selected]="true">
      <ng-template kendoTabContent>
        <app-my-time-tracking></app-my-time-tracking>
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab [title]="t('myReport.title')">
      <ng-template kendoTabContent>
        <app-my-time-reporting></app-my-time-reporting>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</ng-container>
